import FetchCoinsRepository from "./FetchCoinsRepository";
import WithDraw from "./WithDraw";
import VeriffRepository from "./VeriffRepository";

const repositories = {
  setWithdraw: WithDraw,
  getCoinsStats: FetchCoinsRepository,
  veriff: VeriffRepository,
};

export const RepositoryFactory = {
  get: (name) => repositories[name],
};
